import {
  EarningMechanismExternalFulfillmentFragment,
  EarningMechanismFragment,
  EarningMechanismLoyaltyEventFragment,
  EarningMechanismMembershipEventFragment,
  EarningMechanismPointSpendFragment,
  EarningMechanismProductDiscountFragment,
  EarningMechanismProductPurchaseFragment,
  EarningMechanismTotalEligiblePurchaseFragment,
  EarningMechanismTotalEligiblePurchaseOverTimeFragment,
  EarningMechanismTotalSpendOverTimeFragment,
  EarningMechanismTransactionDiscountFragment,
  EarningMechanismVarietyDiscountFragment,
  EarningMechanismVarietyPurchaseFragment,
  EarningMechanismVarietyPurchaseOverTimeFragment,
  EarningMechanismVisitsFragment,
  EarningMechanismTotalSpendOnTransactionFragment,
  EarningMechanismSpinWheelGameFragment,
  EarningMechanismPromocodesFragment,
  EarningMechanismStoredValueDiscountFragment,
} from '@occc/graphql';

class EarningMechanismHelper {
  isTotalEligiblePurchase = (
    earningMechanism?: EarningMechanismFragment | null,
  ): earningMechanism is EarningMechanismTotalEligiblePurchaseFragment => {
    if (!earningMechanism) return false;
    return earningMechanism.__typename === 'EarningMechanismTotalEligiblePurchase';
  };

  isExternalFulfillment = (
    earningMechanism?: EarningMechanismFragment | null,
  ): earningMechanism is EarningMechanismExternalFulfillmentFragment => {
    if (!earningMechanism) return false;
    return earningMechanism.__typename === 'EarningMechanismExternalFulfillment';
  };

  isTotalEligiblePurchaseOverTime = (
    earningMechanism?: EarningMechanismFragment | null,
  ): earningMechanism is EarningMechanismTotalEligiblePurchaseOverTimeFragment => {
    if (!earningMechanism) return false;
    return earningMechanism.__typename === 'EarningMechanismTotalEligiblePurchaseOverTime';
  };

  isProductPurchase = (
    earningMechanism?: EarningMechanismFragment | null,
  ): earningMechanism is EarningMechanismProductPurchaseFragment => {
    if (!earningMechanism) return false;
    return earningMechanism.__typename === 'EarningMechanismProductPurchase';
  };

  isTotalSpendOverTime = (
    earningMechanism?: EarningMechanismFragment | null,
  ): earningMechanism is EarningMechanismTotalSpendOverTimeFragment => {
    if (!earningMechanism) return false;
    return earningMechanism.__typename === 'EarningMechanismTotalSpendOverTime';
  };

  isTotalSpendOnTransaction = (
    earningMechanism?: EarningMechanismFragment | null,
  ): earningMechanism is EarningMechanismTotalSpendOnTransactionFragment => {
    if (!earningMechanism) return false;
    return earningMechanism.__typename === 'EarningMechanismTotalSpendOnTransaction';
  };

  isVisits = (
    earningMechanism?: EarningMechanismFragment | null,
  ): earningMechanism is EarningMechanismVisitsFragment => {
    if (!earningMechanism) return false;
    return earningMechanism.__typename === 'EarningMechanismVisits';
  };

  isLoyaltyEvent = (
    earningMechanism?: EarningMechanismFragment | null,
  ): earningMechanism is EarningMechanismLoyaltyEventFragment => {
    if (!earningMechanism) return false;
    return earningMechanism.__typename === 'EarningMechanismLoyaltyEvent';
  };

  isMembershipEvent = (
    earningMechanism?: EarningMechanismFragment | null,
  ): earningMechanism is EarningMechanismMembershipEventFragment => {
    if (!earningMechanism) return false;
    return earningMechanism.__typename === 'EarningMechanismMembershipEvent';
  };

  isPointSpend = (
    earningMechanism?: EarningMechanismFragment | null,
  ): earningMechanism is EarningMechanismPointSpendFragment => {
    if (!earningMechanism) return false;
    return earningMechanism.__typename === 'EarningMechanismPointSpend';
  };

  isProductDiscount = (
    earningMechanism?: EarningMechanismFragment | null,
  ): earningMechanism is EarningMechanismProductDiscountFragment => {
    if (!earningMechanism) return false;
    return earningMechanism.__typename === 'EarningMechanismProductDiscount';
  };

  isVarietyPurchase = (
    earningMechanism?: EarningMechanismFragment | null,
  ): earningMechanism is EarningMechanismVarietyPurchaseFragment => {
    if (!earningMechanism) return false;
    return earningMechanism.__typename === 'EarningMechanismVarietyPurchase';
  };

  isVarietyPurchaseOverTime = (
    earningMechanism?: EarningMechanismFragment | null,
  ): earningMechanism is EarningMechanismVarietyPurchaseOverTimeFragment => {
    if (!earningMechanism) return false;
    return earningMechanism.__typename === 'EarningMechanismVarietyPurchaseOverTime';
  };

  isTransactionDiscount = (
    earningMechanism?: EarningMechanismFragment | null,
  ): earningMechanism is EarningMechanismTransactionDiscountFragment => {
    if (!earningMechanism) return false;
    return earningMechanism.__typename === 'EarningMechanismTransactionDiscount';
  };

  isVarietyDiscount = (
    earningMechanism?: EarningMechanismFragment | null,
  ): earningMechanism is EarningMechanismVarietyDiscountFragment => {
    if (!earningMechanism) return false;
    return earningMechanism.__typename === 'EarningMechanismVarietyDiscount';
  };

  isSpinWheelGame = (
    earningMechanism?: EarningMechanismFragment | null,
  ): earningMechanism is EarningMechanismSpinWheelGameFragment => {
    if (!earningMechanism) return false;
    return earningMechanism.__typename === 'EarningMechanismSpinWheelGame';
  };

  isPromocodes = (
    earningMechanism?: EarningMechanismFragment | null,
  ): earningMechanism is EarningMechanismPromocodesFragment => {
    if (!earningMechanism) return false;
    return earningMechanism.__typename === 'EarningMechanismPromocodes';
  };

  isEarningMechanismStoredValueDiscount = (
    earningMechanism: EarningMechanismFragment | null,
  ): earningMechanism is EarningMechanismStoredValueDiscountFragment => {
    if (!earningMechanism) return false;
    return earningMechanism.__typename === 'EarningMechanismStoredValueDiscount';
  };
}

export const earningMechanismHelper = new EarningMechanismHelper();

export const isHiddenUntilProgressEnabled = (
  earningMechanism?: EarningMechanismFragment | null,
): earningMechanism is
  | EarningMechanismTotalEligiblePurchaseOverTimeFragment
  | EarningMechanismVarietyPurchaseOverTimeFragment => {
  return (
    earningMechanismHelper.isTotalEligiblePurchaseOverTime(earningMechanism) ||
    earningMechanismHelper.isVarietyPurchaseOverTime(earningMechanism)
  );
};

export const isStayVisibleWhileInProgressEnabled = (
  earningMechanism?: EarningMechanismFragment | null,
): earningMechanism is
  | EarningMechanismTotalEligiblePurchaseOverTimeFragment
  | EarningMechanismTotalSpendOverTimeFragment
  | EarningMechanismVarietyPurchaseOverTimeFragment => {
  return (
    earningMechanismHelper.isTotalEligiblePurchaseOverTime(earningMechanism) ||
    earningMechanismHelper.isTotalSpendOverTime(earningMechanism) ||
    earningMechanismHelper.isVarietyPurchaseOverTime(earningMechanism)
  );
};
